import React from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import classes from "./CustomDatePicker.module.scss";
import "./CustomDatePicker.scss";

dayjs.extend(customParseFormat);

interface ICustomDatePickerProps {
  name: string;
  dateFormat?: string;
  className?: string;
  label?: string;
  value?: Dayjs;
  curDate?: string;
  required?: boolean;
  valid?: boolean;
  shouldValidate?: boolean;
  errorMessage?: string;
  touched?: boolean;
  onChangeDate?: (date: string) => void;
  disabled?: boolean;
  picker?: 'date' | 'week' | 'month' | 'quarter' | 'year';
  disabledDate?: (currentDate: Dayjs) => boolean;
}

function CustomDatePicker({
  className,
  required,
  valid,
  shouldValidate,
  errorMessage,
  curDate,
  onChangeDate,
  label,
  dateFormat = "DD.MM.YYYY",
  name,
  picker = 'date',
  disabledDate,
  ...rest
}: ICustomDatePickerProps) {

  let cls = [classes.wrap];

  if (className) {
    cls = [...cls, className];
  }

  if (required) {
    cls = [...cls, classes.requred];
  }

  if (!valid && shouldValidate) {
    cls = [...cls, classes.error];
    cls = [...cls, "ant-picker-custom-error"];
  }

  const errorMessageTemplate = errorMessage && <span className={classes.error_message}>{errorMessage}</span>;
  const labelTemplate = label ? <label className={classes.label}>{label}</label> : null;

  const serverDateFormat = "YYYY-MM-DD";

  if (curDate) {
    rest.value = dayjs(curDate, serverDateFormat);
  }

  return (
    <div className={cls.join(" ")}>
      <div className={classes.container}>
        {labelTemplate}
        <DatePicker
          name={name}
          format={dateFormat}
          locale={locale}
          className={"ant-picker-custom"}
          onChange={(value) => {
            const formattedDate = value ? value.format(serverDateFormat) : "";
            onChangeDate?.(formattedDate);
          }}
          picker={picker}
          disabledDate={disabledDate}
          {...rest}
        />
      </div>
      {errorMessageTemplate}
    </div>
  );
}

export default CustomDatePicker;